import { css as h, LitElement as m, html as g } from "lit";
import { query as E, property as i, customElement as f } from "lit/decorators.js";
import { classMap as w } from "lit/directives/class-map.js";
import { o as x, f as O, s as S, c as I, b as P } from "./floating-ui.dom-Cma46hoU.js";
import { b as y, f as $ } from "./styles-scZ6dVz-.js";
import { b as p, a as k } from "./events-CkEPl0SM.js";
import { g as C } from "./a11y-DxQW21Jt.js";
var A = Object.defineProperty, L = Object.getOwnPropertyDescriptor, a = (e, t, r, s) => {
  for (var n = s > 1 ? void 0 : s ? L(t, r) : t, l = e.length - 1, c; l >= 0; l--)
    (c = e[l]) && (n = (s ? c(t, r, n) : c(n)) || n);
  return s && n && A(t, r, n), n;
};
let o = class extends m {
  constructor() {
    super(...arguments), this.menuId = C("ark-menu"), this.open = !1, this.placement = "bottom-start", this.offset = 4, this.closeOnOutside = !0, this.closeOnSelect = !0, this.handleOutsideClick = (e) => {
      this.open && this.closeOnOutside && !this.contains(e.target) && this.hide();
    }, this.handleKeydown = (e) => {
      if (!this.open) {
        (document.activeElement === this || this.contains(document.activeElement)) && (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") && (e.preventDefault(), this.show());
        return;
      }
      if (e.key === "Escape") {
        this.hide(), this.focusTrigger();
        return;
      }
      if (e.key === "Tab") {
        this.hide();
        return;
      }
      const t = this.getMenuItems(), r = t.indexOf(document.activeElement);
      if (e.key === "ArrowDown") {
        e.preventDefault();
        const s = (r + 1) % t.length;
        t[s]?.focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        const s = (r - 1 + t.length) % t.length;
        t[s]?.focus();
      }
    }, this.handleItemSelect = (e) => {
      const t = e.detail;
      p(this, "ark-select", t), this.closeOnSelect && (this.hide(), this.focusTrigger());
    };
  }
  /** Open the menu */
  show() {
    this.open || (this.open = !0);
  }
  /** Close the menu */
  hide() {
    this.open && (this.open = !1);
  }
  /** Toggle the menu */
  toggle() {
    this.open = !this.open;
  }
  async updatePosition() {
    if (!this.triggerElement || !this.contentElement) return;
    const e = this.triggerElement.querySelector("slot")?.assignedElements()[0] || this.triggerElement, t = [
      x(this.offset),
      O(),
      S({ padding: 8 })
    ], { x: r, y: s } = await I(
      e,
      this.contentElement,
      {
        placement: this.placement,
        middleware: t
      }
    );
    Object.assign(this.contentElement.style, {
      left: `${r}px`,
      top: `${s}px`
    });
  }
  handleTriggerClick(e) {
    e.stopPropagation(), this.toggle();
  }
  getMenuItems() {
    const e = this.shadowRoot?.querySelector("slot:not([name])");
    return e ? e.assignedElements({ flatten: !0 }).filter((t) => t.tagName.toLowerCase() === "ark-menu-item" && !t.hasAttribute("disabled")) : [];
  }
  focusTrigger() {
    const t = this.triggerElement.querySelector("slot")?.assignedElements({ flatten: !0 })[0];
    t ? t.focus() : this.triggerElement.focus();
  }
  updated(e) {
    if (e.has("open"))
      if (this.open) {
        this.updatePosition();
        const t = this.triggerElement.querySelector("slot")?.assignedElements()[0] || this.triggerElement;
        this.cleanupAutoUpdate = P(
          t,
          this.contentElement,
          () => this.updatePosition()
        ), document.addEventListener("click", this.handleOutsideClick), document.addEventListener("keydown", this.handleKeydown), this.addEventListener("ark-item-select", this.handleItemSelect), p(this, k.OPEN), requestAnimationFrame(() => {
          const r = this.getMenuItems();
          r.length > 0 && r[0].focus();
        });
      } else
        this.cleanupAutoUpdate?.(), document.removeEventListener("click", this.handleOutsideClick), document.removeEventListener("keydown", this.handleKeydown), this.removeEventListener("ark-item-select", this.handleItemSelect), p(this, k.CLOSE);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.cleanupAutoUpdate?.(), document.removeEventListener("click", this.handleOutsideClick), document.removeEventListener("keydown", this.handleKeydown), this.removeEventListener("ark-item-select", this.handleItemSelect);
  }
  render() {
    const e = {
      content: !0,
      open: this.open
    };
    return g`
      <div
        part="trigger"
        class="trigger"
        @click=${this.handleTriggerClick}
        @keydown=${this.handleKeydown}
        aria-haspopup="menu"
        aria-expanded=${this.open}
        aria-controls=${this.menuId}
      >
        <slot name="trigger"></slot>
      </div>

      <div
        part="content"
        class=${w(e)}
        id=${this.menuId}
        role="menu"
        aria-labelledby=${this.menuId}
        @keydown=${this.handleKeydown}
        tabindex="-1"
      >
        <slot></slot>
      </div>
    `;
  }
};
o.styles = [
  y,
  h`
      :host {
        display: inline-block;
      }

      .trigger {
        display: inline-flex;
        cursor: pointer;
      }

      .content {
        position: fixed;
        z-index: var(--r5-z-dropdown);
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        box-shadow: var(--r5-shadow-lg);
        padding: var(--r5-space-1);
        min-width: 12rem;
        opacity: 0;
        visibility: hidden;
        transform: scale(0.95);
        transition: opacity var(--r5-duration-fast) var(--r5-ease-default),
                    visibility var(--r5-duration-fast) var(--r5-ease-default),
                    transform var(--r5-duration-fast) var(--r5-ease-default);
        display: flex;
        flex-direction: column;
        gap: 2px;
      }

      .content.open {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }

      @media (prefers-reduced-motion: reduce) {
        .content {
          transition: none;
        }
      }
    `
];
a([
  E(".trigger")
], o.prototype, "triggerElement", 2);
a([
  E(".content")
], o.prototype, "contentElement", 2);
a([
  i({ type: Boolean, reflect: !0 })
], o.prototype, "open", 2);
a([
  i({ type: String })
], o.prototype, "placement", 2);
a([
  i({ type: Number })
], o.prototype, "offset", 2);
a([
  i({ type: Boolean, attribute: "close-on-outside" })
], o.prototype, "closeOnOutside", 2);
a([
  i({ type: Boolean, attribute: "close-on-select" })
], o.prototype, "closeOnSelect", 2);
o = a([
  f("ark-menu")
], o);
var D = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, u = (e, t, r, s) => {
  for (var n = s > 1 ? void 0 : s ? _(t, r) : t, l = e.length - 1, c; l >= 0; l--)
    (c = e[l]) && (n = (s ? c(t, r, n) : c(n)) || n);
  return s && n && D(t, r, n), n;
};
let d = class extends m {
  constructor() {
    super(...arguments), this.disabled = !1, this.variant = "default";
  }
  handleClick(e) {
    if (this.disabled) {
      e.preventDefault(), e.stopPropagation();
      return;
    }
    p(this, "ark-item-select", {
      value: this.value,
      originalEvent: e
    });
  }
  handleKeydown(e) {
    this.disabled || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.stopPropagation(), this.click());
  }
  render() {
    return g`
      <button
        type="button"
        ?disabled=${this.disabled}
        @click=${this.handleClick}
        @keydown=${this.handleKeydown}
        tabindex="-1"
        role="menuitem"
      >
        <span class="content">
          <slot name="icon"></slot>
          <slot></slot>
        </span>
        <slot name="shortcut">
          <span class="shortcut"></span>
        </slot>
      </button>
    `;
  }
};
d.styles = [
  y,
  $,
  h`
      :host {
        display: block;
      }

      button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: var(--r5-space-2) var(--r5-space-3);
        border: none;
        background: transparent;
        color: var(--r5-text);
        border-radius: var(--r5-radius-sm);
        cursor: pointer;
        font-family: inherit;
        font-size: var(--r5-text-sm);
        text-align: left;
        transition: background-color var(--r5-duration-fast);
        outline: none;
      }

      button:hover, button:focus-visible {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-strong);
      }
      
      button:active {
        background-color: var(--r5-bg-subtle);
      }

      button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background-color: transparent !important;
      }

      .content {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
      }

      .shortcut {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        margin-left: var(--r5-space-4);
      }
      
      /* Danger variant */
      :host([variant="danger"]) button {
        color: var(--r5-color-danger-600);
      }
      
      :host([variant="danger"]) button:hover,
      :host([variant="danger"]) button:focus-visible {
        background-color: var(--r5-color-danger-50);
      }
    `
];
u([
  i()
], d.prototype, "value", 2);
u([
  i({ type: Boolean, reflect: !0 })
], d.prototype, "disabled", 2);
u([
  i({ type: String, reflect: !0 })
], d.prototype, "variant", 2);
d = u([
  f("ark-menu-item")
], d);
let v = class extends m {
  render() {
    return g``;
  }
};
v.styles = h`
      :host {
        display: block;
        height: 1px;
        margin: var(--r5-space-1) 0;
        background-color: var(--r5-border);
      }
    `;
v = u([
  f("ark-menu-separator")
], v);
let b = class extends m {
  render() {
    return g`<slot></slot>`;
  }
};
b.styles = [
  y,
  h`
      :host {
        display: block;
        padding: var(--r5-space-2) var(--r5-space-3);
        padding-bottom: var(--r5-space-1);
        font-size: 10px;
        font-weight: var(--r5-font-semibold);
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: var(--r5-text-muted);
        user-select: none;
      }
    `
];
b = u([
  f("ark-menu-label")
], b);
export {
  o as A,
  d as a,
  v as b,
  b as c
};
//# sourceMappingURL=ark-menu-item-DMMvtydA.js.map
